module.exports = __webpack_public_path__ + "img/pala_fondo_azul_padel.34fc162e.jpg";